import { render, staticRenderFns } from "./stylesBlock.vue?vue&type=template&id=4ef89c1f&"
import script from "./stylesBlock.vue?vue&type=script&lang=js&"
export * from "./stylesBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports